import { TimelineLite } from 'gsap';
import { SymbolIdleAnimationController } from "@nolimitcity/slot-game/bin/game/idleanimation/symbolidleanimation/SymbolIdleAnimationController";
import { BarbarianFuryGameConfig } from "../../BarbarianFuryGameConfig";
import { Reels } from '@nolimitcity/slot-game/bin/core/reel/reelarea/Reels';
import { MathHelper } from '@nolimitcity/slot-game/bin/core/utils/MathHelper';

export class BFSymbolIdleAnimationController extends SymbolIdleAnimationController {
    constructor() {
        super({
            startTime: 2,
            minInterval: 3,
            maxInterval: 5
        });
    }

    protected playIdleAnimation(): void {
        let tl: TimelineLite = new TimelineLite();
        const reelId: number = MathHelper.randomNumberInRange(0, BarbarianFuryGameConfig.instance.REELS_NUM - 1);
        const symId: number = MathHelper.randomNumberInRange(0, BarbarianFuryGameConfig.instance.SYMBOLS_NUM_IN_REEL[2] - 1);
        const symbol = Reels.getSymbol(reelId, symId)!;

        if (BarbarianFuryGameConfig.instance.SYMBOLS_ALL.indexOf(symbol.symName.split("*")[0]) > -1) {
            if (symbol) {
                tl.add(
                    symbol.changeState({
                        state: BarbarianFuryGameConfig.instance.SYMBOL_STATES.idle!
                    })
                );
                tl.add(
                    symbol.changeState({
                        state: BarbarianFuryGameConfig.instance.SYMBOL_STATES.normal
                    })
                );
            }
        }
    }

    protected stopIdleAnimation(): void {
        super.stopIdleAnimation && super.stopIdleAnimation();
    }
}